// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from "firebase/auth"
import { getFirestore } from "firebase/firestore";

// import firebase from "firebase"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxUUdrHqTCnw8jedzhqnvGjumc2NGSeyo",
  authDomain: "survey-app-122c1.firebaseapp.com",
  projectId: "survey-app-122c1",
  storageBucket: "survey-app-122c1.appspot.com",
  messagingSenderId: "1071911452302",
  appId: "1:1071911452302:web:e16bfc37dd881db5d013df",
  measurementId: "G-CWVYYYGW7N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
const analytics = getAnalytics(app);